import React, { useEffect, useState } from "react";
import ReactQuill from 'react-quill';
import Select from 'react-select'

import { stripHtml, customSelectStyles } from './sharedUtils';
import 'react-quill/dist/quill.snow.css';
const quillModules = {
  toolbar: [
    [{ 'header': [2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ 'align': [] }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
    ['link', 'image'],
    ['clean']
  ]
}

const quillFormats = [
  'header',
  'bold', 'italic', 'underline', 'strike', 'blockquote', 'align',
  'list', 'bullet', 'indent',
  'link', 'image'
]
const FormDetails = (props) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors, touched,
    setFieldValue
  } = props;
  const [categories, setCategories] = useState([]);
  const fetchCategories = async () => {
    const resp = await fetch('/account/listings/categories.json');
    const data = await resp.json()
    console.log('dd', data);
    setCategories(data);
  }

  useEffect(() => {
    fetchCategories()
  }, [])
  const catOptions = categories.map((cat) => ({ label: cat.name, value: cat.name }));
  console.log('errors', errors, values);
  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-tag"></i> Details
          </h3>
        </div>
        <div className="row with-forms">
          <div className="col-md-6">
            <h5>Listing Name
              <sup className="required">*</sup>
            </h5>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Listing Title"
              autoComplete="listing-title"
              value={`${values.name || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              required={true}
              className={
                errors.name && touched.name
                  ? "form-input search-field error"
                  : "form-input search-field"
              }
            />
          </div>
          <div className="col-md-6">
            <h5>Category
              <sup className="required">*</sup>
            </h5>
            <div className="intro-search-field">
              <div className="">
                <Select
                  styles={customSelectStyles}
                  className="react-select-wrapper"
                  classNamePrefix="react-select"
                  options={catOptions}
                  isMulti={true}
                  name="categories"
                  required={true}
                  value={catOptions.filter((cat) => (values.categories && values.categories.find((x) => (x === cat.value))))}
                  onChange={e => { console.log('change', e); return setFieldValue('categories', e ? e.map((x) => (x.value)) : null) }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="row with-forms">

          <div className="col-md-12">
            <h5>Description
              <sup className="required">*</sup>
            </h5>
            <textarea
              style={{ height: '0px', width: '0px', visibility: 'hidden' }}
              required={true} className="invisibled"
              name="description"
              value={`${stripHtml(values.description) || ''}`}
              onChange={e => (e)}
            ></textarea>
            <ReactQuill
              // theme="bubble"
              theme="snow"
              value={`${values.description || ''}`}
              onChange={(value) => setFieldValue('description', value)}
              modules={quillModules}
              formats={quillFormats}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormDetails;
